(function(){
  var BALM='cast-iron-conditioning-balm';
  var ACCESSORIES=['handspun-french-rolling-pin-light-finish','pot-pan-scraper','large-handmade-kitchen-spoon','large-handmade-kitchen-turner'];
  var productCache={};
  var skilletCache={};

  function money(cents){
    var n=Number(cents||0)/100;
    return '$'+n.toFixed(2).replace(/\.00$/,'');
  }
  function esc(value){
    return String(value||'').replace(/[&<>\"]/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch];});
  }
  function normalized(value){
    return String(value||'').toLowerCase().replace(/[^a-z0-9]/g,'');
  }
  function firstAvailableVariant(product){
    if(!product||!product.variants||!product.variants.length) return null;
    for(var i=0;i<product.variants.length;i++){ if(product.variants[i].available) return product.variants[i]; }
    return null;
  }
  function imageFor(product){
    if(!product) return '';
    if(typeof product.featured_image==='string') return product.featured_image;
    if(product.featured_image&&product.featured_image.src) return product.featured_image.src;
    if(product.images&&product.images.length){ return typeof product.images[0]==='string'?product.images[0]:product.images[0].src; }
    return '';
  }
  function fetchProduct(handle){
    if(productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/'+handle+'.js',{credentials:'same-origin'}).then(function(res){
      if(!res.ok) return null;
      return res.json();
    }).then(function(product){ productCache[handle]=product; return product; }).catch(function(){ return null; });
  }
  function loadProducts(){
    return Promise.all([BALM].concat(ACCESSORIES).map(fetchProduct)).then(function(products){
      return products.filter(function(product){ return product&&firstAvailableVariant(product); });
    });
  }
  function searchProducts(query){
    var url='/search/suggest.json?q='+encodeURIComponent(query)+'&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide';
    return fetch(url,{credentials:'same-origin'}).then(function(res){
      if(!res.ok) return [];
      return res.json();
    }).then(function(data){
      return data&&data.resources&&data.resources.results&&data.resources.results.products||[];
    }).catch(function(){ return []; });
  }
  function isBrandSkillet(product,vendor,excludedHandle){
    var title=String(product&&product.title||'');
    return product && product.handle!==excludedHandle &&
      normalized(product.vendor)===normalized(vendor) &&
      /skillet/i.test(title) &&
      /(?:#|no\.?\s*|number\s*)8\b/i.test(title);
  }
  function findBrandSkillet(vendor,excludedHandle){
    if(!vendor) return Promise.resolve(null);
    var key=normalized(vendor)+'|'+String(excludedHandle||'');
    if(skilletCache[key]) return skilletCache[key];
    var queries=[vendor+' #8 skillet',vendor+' No. 8 skillet',vendor+' 8 skillet'];
    skilletCache[key]=Promise.all(queries.map(searchProducts)).then(function(groups){
      var seen={};
      var candidates=[];
      groups.forEach(function(products){
        products.forEach(function(product){
          if(!seen[product.handle]&&isBrandSkillet(product,vendor,excludedHandle)){
            seen[product.handle]=true;
            candidates.push(product.handle);
          }
        });
      });
      function availableAt(index){
        if(index>=candidates.length) return Promise.resolve(null);
        return fetchProduct(candidates[index]).then(function(product){
          return firstAvailableVariant(product)?product:availableAt(index+1);
        });
      }
      return availableAt(0);
    });
    return skilletCache[key];
  }
  function findSuggestedSkillet(vendor,excludedHandle){
    return findBrandSkillet(vendor,excludedHandle).then(function(product){
      if(product||normalized(vendor)==='griswold') return product;
      return findBrandSkillet('Griswold',excludedHandle);
    });
  }
  function skilletLabel(product,vendor){
    return normalized(product&&product.vendor)===normalized(vendor)?'Same-Brand #8 Skillet':'Griswold #8 Skillet';
  }
  function refreshCart(){
    ['cart:refresh','cart:updated','dispatch:cart-drawer:refresh'].forEach(function(name){
      document.dispatchEvent(new CustomEvent(name,{bubbles:true}));
      window.dispatchEvent(new CustomEvent(name));
    });
  }
  function cardContent(product,label,buttonText){
    var variant=firstAvailableVariant(product);
    if(!variant) return '';
    var full=Number(variant.price||0);
    return '<div class="cacb-slot__check" aria-hidden="true"><svg width="11" height="9" viewBox="0 0 11 9" fill="none"><path d="M1 4.5l3 3 6-7" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="cacb-slot__img">'+(imageFor(product)?'<img src="'+imageFor(product)+'" alt="'+esc(product.title)+'" width="400" height="400" loading="lazy">':'')+'</div><div class="cacb-slot__body"><p class="cacb-slot__type-tag">'+label+'</p><p class="cacb-slot__name">'+esc(product.title)+'</p><div class="cacb-slot__prices"><span class="cacb-slot__price-new">'+money(full)+'</span></div><p class="cacb-slot__cta"><span class="cta-add">'+buttonText+'</span><span class="cta-added">Added</span></p></div>';
  }
  function accessoryCard(product){
    var variant=firstAvailableVariant(product);
    if(!variant) return null;
    var el=document.createElement('div');
    el.className='cacb-carousel-slot cacb-slot';
    el.setAttribute('role','checkbox');
    el.setAttribute('tabindex','0');
    el.setAttribute('aria-checked','false');
    el.dataset.variantId=variant.id;
    el.dataset.fullPrice=Number(variant.price||0);
    el.dataset.title=product.title;
    el.innerHTML=cardContent(product,'Culinary Accessories','+ Add to order');
    return el;
  }
  function renderSkilletSlot(el,product,vendor){
    var variant=firstAvailableVariant(product);
    if(!el||!variant) return false;
    el.hidden=false;
    el.dataset.variantId=variant.id;
    el.dataset.fullPrice=Number(variant.price||0);
    el.dataset.title=product.title;
    el.innerHTML=cardContent(product,skilletLabel(product,vendor),'+ Add to order');
    return true;
  }
  function bindSelectable(el,selected,updateSummary){
    if(el.dataset.cbBound) return;
    el.dataset.cbBound='true';
    function toggle(){
      var key=String(el.dataset.variantId);
      var active=el.getAttribute('aria-checked')==='true';
      if(active){
        el.setAttribute('aria-checked','false');
        el.classList.remove('is-selected');
        selected.delete(key);
      }else{
        el.setAttribute('aria-checked','true');
        el.classList.add('is-selected');
        selected.set(key,{id:key,title:el.dataset.title,fullPrice:Number(el.dataset.fullPrice||0)});
      }
      updateSummary();
    }
    el.addEventListener('click',toggle);
    el.addEventListener('keydown',function(event){
      if(event.key==='Enter'||event.key===' '){ event.preventDefault(); toggle(); }
    });
  }
  function initProduct(section){
    if(section.dataset.cbReady) return;
    section.dataset.cbReady='true';
    var selected=new Map();
    var summary=section.querySelector('.cacb-upsell__summary');
    var rows=section.querySelector('[id^="cacb-summary-rows"]');
    function updateSummary(){
      var items=Array.from(selected.values());
      if(rows){ rows.innerHTML=items.map(function(item){ return '<div class="cacb-summary__item"><span>'+esc(item.title)+'</span><span>'+money(item.fullPrice)+'</span></div>'; }).join(''); }
      if(summary) summary.hidden=!items.length;
    }
    section.querySelectorAll('.cacb-slot--fixed:not([data-cacb-brand-skillet])').forEach(function(el){ bindSelectable(el,selected,updateSummary); });
    findSuggestedSkillet(section.dataset.productVendor,section.dataset.productHandle).then(function(skillet){
      var slot=section.querySelector('[data-cacb-brand-skillet]');
      if(renderSkilletSlot(slot,skillet,section.dataset.productVendor)){ bindSelectable(slot,selected,updateSummary); }
    });
    loadProducts().then(function(products){
      var accessoryProducts=products.filter(function(product){ return ACCESSORIES.indexOf(product.handle)!==-1; });
      var box=section.querySelector('.cacb-carousel__slots');
      var prev=section.querySelector('[id^="cacb-prev"]');
      var next=section.querySelector('[id^="cacb-next"]');
      var counter=section.querySelector('[id^="cacb-counter"]');
      var index=0;
      function render(){
        if(!box) return;
        box.innerHTML='';
        accessoryProducts.slice(index,index+2).forEach(function(product){
          var card=accessoryCard(product);
          if(card){ bindSelectable(card,selected,updateSummary); box.appendChild(card); }
        });
        if(prev) prev.disabled=index<=0;
        if(next) next.disabled=index+2>=accessoryProducts.length;
        if(counter) counter.textContent=accessoryProducts.length?(index+1)+'-'+Math.min(index+2,accessoryProducts.length)+' of '+accessoryProducts.length:'0';
      }
      if(prev&&!prev.dataset.cbBound){ prev.dataset.cbBound='true'; prev.addEventListener('click',function(event){ event.preventDefault(); index=Math.max(0,index-2); render(); }); }
      if(next&&!next.dataset.cbBound){ next.dataset.cbBound='true'; next.addEventListener('click',function(event){ event.preventDefault(); index=Math.min(Math.max(0,accessoryProducts.length-2),index+2); render(); }); }
      render();
    });
    var form=document.querySelector('form[action*="/cart/add"]');
    if(form&&!form.dataset.cbAddonsBound){
      form.dataset.cbAddonsBound='true';
      form.addEventListener('submit',function(){
        var items=Array.from(selected.values());
        if(!items.length) return;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:items.map(function(item){return {id:Number(item.id),quantity:1,properties:{_cacb_upsell:'true'}};})})}).then(refreshCart).catch(function(){});
      },true);
    }
  }
  function cartCard(product,label){
    var variant=firstAvailableVariant(product);
    if(!variant) return '';
    return '<div class="cacb-upsell-card"><div class="cacb-upsell-card__img">'+(imageFor(product)?'<img src="'+imageFor(product)+'" alt="'+esc(product.title)+'" loading="lazy">':'')+'</div><div class="cacb-upsell-card__body"><p class="cacb-upsell-card__type">'+label+'</p><p class="cacb-upsell-card__name">'+esc(product.title)+'</p><div class="cacb-upsell-card__prices"><span class="cacb-upsell-card__price-new">'+money(variant.price)+'</span></div><button class="cacb-upsell-card__btn" type="button" data-variant-id="'+variant.id+'">Add</button></div></div>';
  }
  function bindCartButtons(scope){
    scope.querySelectorAll('.cacb-upsell-card__btn:not([data-cb-bound])').forEach(function(button){
      button.dataset.cbBound='true';
      button.addEventListener('click',function(){
        var original=button.textContent;
        button.disabled=true;
        button.textContent='Adding';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({id:Number(button.dataset.variantId),quantity:1,properties:{_cacb_upsell:'true'}})}).then(function(res){
          if(!res.ok) throw new Error('add failed');
          button.textContent='Added';
          refreshCart();
        }).catch(function(){ button.textContent='Try again'; }).finally(function(){ setTimeout(function(){ button.disabled=false; button.textContent=original; },1300); });
      });
    });
  }
  function cartBrandSkillet(){
    return fetch('/cart.js',{credentials:'same-origin'}).then(function(res){ return res.json(); }).then(function(cart){
      var item=(cart.items||[]).filter(function(line){
        return line.vendor && line.product_type!=='Merchandise' && line.handle!==BALM && ACCESSORIES.indexOf(line.handle)===-1;
      })[0];
      return item?findSuggestedSkillet(item.vendor,item.handle).then(function(product){ return {product:product,vendor:item.vendor}; }):null;
    }).catch(function(){ return null; });
  }
  function renderCartHost(host){
    if(!host||host.dataset.cbReady) return;
    host.dataset.cbReady='true';
    Promise.all([loadProducts(),cartBrandSkillet()]).then(function(results){
      var products=results[0];
      var suggested=results[1];
      var skillet=suggested&&suggested.product;
      var balm=products.filter(function(p){return p.handle===BALM;})[0];
      var accessories=products.filter(function(p){return ACCESSORIES.indexOf(p.handle)!==-1;}).slice(0,2);
      var cards=[cartCard(balm,'Balm'),cartCard(accessories[0],'Culinary Accessories'),cartCard(accessories[1],'Culinary Accessories'),cartCard(skillet,skilletLabel(skillet,suggested&&suggested.vendor))];
      host.innerHTML='<section class="cacb-cart-upsell" aria-label="Complete your kit"><div class="cacb-cart-upsell__header"><p class="cacb-cart-upsell__title">Complete Your Kit</p></div><div class="cacb-cart-upsell__track-wrap"><div class="cacb-cart-upsell__track">'+cards.join('')+'</div></div><p class="cacb-cart-upsell__note">Add to your order in one click</p></section>';
      bindCartButtons(host);
    });
  }
  function mount(){
    document.querySelectorAll('.cacb-upsell').forEach(initProduct);
    document.querySelectorAll('.cacb-cart-upsell-host').forEach(renderCartHost);
    document.querySelectorAll('.cart-item-upsells,[data-merge="cross-sells"]').forEach(function(el){ el.style.display='none'; });
    var drawer=document.querySelector('.cart-drawer__content,.cart-drawer__items,.drawer__contents');
    if(drawer&&!drawer.querySelector('.cacb-cart-upsell-host')){
      var host=document.createElement('div');
      host.className='cacb-cart-upsell-host cart-drawer__content-item';
      drawer.appendChild(host);
      renderCartHost(host);
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',mount); else mount();
  ['cart:refresh','cart:updated','dispatch:cart-drawer:refresh'].forEach(function(name){ document.addEventListener(name,function(){ setTimeout(mount,250); }); });
  new MutationObserver(function(){ mount(); }).observe(document.documentElement,{childList:true,subtree:true});
})();